import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import {
  clearOAuthTokenFromAddressBar,
  consumePendingOAuthToken,
} from "@/lib/oauthCallbackToken";

/** OAuth visszatérés (?auth_token=… vagy legacy #auth_token=…). */
export default function GoogleCallback() {
  const { completeGoogleLogin, googleLogin } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const finish = async () => {
      const token = consumePendingOAuthToken();
      clearOAuthTokenFromAddressBar();

      const hash = window.location.hash || "";
      const sessionMatch = hash.match(/session_id=([^&]+)/);

      try {
        if (token) {
          await completeGoogleLogin(token);
        } else if (sessionMatch) {
          await googleLogin(decodeURIComponent(sessionMatch[1]));
        } else {
          if (!cancelled) navigate("/belepes", { replace: true });
          return;
        }
        if (!cancelled) navigate("/fiok", { replace: true });
      } catch {
        if (!cancelled) {
          setError("A bejelentkezés nem sikerült. Próbáld újra.");
        }
      }
    };

    finish();
    return () => {
      cancelled = true;
    };
  }, [completeGoogleLogin, googleLogin, navigate]);

  return (
    <div className="dark min-h-screen bg-anthracite-900 flex flex-col items-center justify-center px-6 text-center">
      {error ? (
        <>
          <p className="text-white text-sm mb-4">{error}</p>
          <Link to="/belepes" className="text-electric text-sm underline">
            Vissza a belépéshez
          </Link>
        </>
      ) : (
        <>
          <Loader2 className="w-8 h-8 text-electric animate-spin" aria-hidden />
          <p className="text-slate-300 text-sm mt-4">Bejelentkezés folyamatban…</p>
        </>
      )}
    </div>
  );
}
